module.exports = __webpack_public_path__ + "static/media/instagram.fad6e6e0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/instagram.svg
// module id = 31
// module chunks = 0